import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as ExactlyIcon } from '../../assets/exactly-icon.svg';
import { CircleBox } from './StepperCircles.styles';
import { EventFormStep } from '../../common/enums/common.enum';
import { useTranslation } from 'react-i18next';

import { palette } from '../../theme';
interface StepperCirclesProps {
  activeStep: EventFormStep;
}

const steps = [
  { step: EventFormStep.GroupAndEventSelectStep, label: 'events.steps.basicDetails' },
  { step: EventFormStep.EventSetupStep, label: 'events.steps.eventsSetup' },
  { step: EventFormStep.ReviewStep, label: 'events.steps.overview' }
];

const StepperCircles: React.FC<StepperCirclesProps> = ({ activeStep }) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" justifyContent="center" mb={5}>
      {steps.map(({ step, label }) => {
        const isActive = step === activeStep;
        const isPrevious = step < activeStep;

        return (
          <Box key={step} display="flex" flexDirection="column" alignItems="center" sx={{ flex: 1 }}>
            <CircleBox circleColor={isPrevious ? palette.primary.light : isActive ? palette.primary.main : palette.text.faint}>
              {isPrevious ? <ExactlyIcon /> : <span>{step + 1}</span>}
            </CircleBox>
            <Typography variant="h5" sx={{ fontWeight: isPrevious ? 600 : 400 }}>
              {t(label)}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default StepperCircles;
